import {Action, createReducer, on} from '@ngrx/store';
// import {HospitalStore} from '../../models/store/user/patient';

// TODO: Add Interfaces

import {editHospital, loadHospitals, paginateHospitals, removeAllHospitals, removeHospitals} from 'src/actions/user/hospital.action';

export const initialState: any = {
  fetching: false,
  data: {
    hospitals: [],
    totalDocuments: 0
  }
};

const hospitalsReducer = createReducer(initialState,
  on(loadHospitals, (state, {payload, totalDocuments}) => (
    {
      ...state,
      data: {
        ...state.data,
        hospitals: [
          ...state.data.hospitals,
          ...payload.filter(p => !state.data.hospitals.find((ds: any) => ds._id === p._id))
        ],
        totalDocuments
      }
    })
  ),
  on(editHospital, (state, {payload}) => (
    {
      ...state,
      data: {
        ...state.data,
        hospitals: state.data.hospitals.map(
          (data: any) => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removeHospitals, (state, {payload}) => (
    {
      ...state,
      data: {
        ...state.data,
        hospitals: state.data.hospitals
          .filter((d: any) => !payload.includes(String(d._id))),
        totalDocuments: state.data.totalDocuments - 1,
      }
    })
  ),
  on(removeAllHospitals, (state) => (
      {
        ...state,
        data: {
          ...state.data,
          hospitals: [],
          totalDocuments: 0
        }
      }
    )
  ),
  on(paginateHospitals, (state) => state)
);

export function reducer(state: any, action: Action): any {
  return hospitalsReducer(state, action);
}
